/** @format */

import React from "react";
import Styles from "./Sidebar.module.css";
import { FaLinkedin, FaWhatsapp, FaGithub, FaTwitter } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

const Sidebar = () => {
  const redirectToPage = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const sendMessage = (link) => {
    window.location.href = link;
  };
  return (
    <aside className={Styles.sidebar}>
      <div className={Styles.socialIcons}>
        <span className={Styles.icons}>
          <FaLinkedin color="#0077B5" onClick={() => redirectToPage("https://www.linkedin.com/in/princekrjha/")} />
        </span>
        <span className={Styles.icons}>
          <FaGithub color="#171515" onClick={() => redirectToPage("https://github.com/princekumarvatsa")} />
        </span>
        <span className={Styles.icons}>
          <SiGmail
            color="#BB001B"
            onClick={(e) =>
              redirectToPage(`https://mail.google.com/mail/?view=cm&fs=1&to=${process.env.REACT_APP_MY_EMAIL}`)
            }
          />
        </span>
        <span className={Styles.icons}>
          <FaTwitter color="#1DA1F2" onClick={() => redirectToPage("https://twitter.com/prince_watsa")} />
        </span>
        <span className={Styles.icons}>
          <FaWhatsapp color="#25D366" onClick={(e) => sendMessage(`https://wa.me/${process.env.REACT_APP_MY_EMAIL}`)} />
        </span>
        <span className={Styles.verticalLine} />
      </div>
    </aside>
  );
};

export default Sidebar;
